<template>
  <div class="modal">
    <div class="modal-window bg-light_gray">
      <img src="@/assets/images/btn-close.svg" @click="closeMobaku" class="btn-close">
      <div class="text-center">
        <div>
          <div class="font-bold">
            {{$t('tour_mobaku_map')}}
          </div>
          <div class="text-sm pt-2">
            {{$t('tour_mobaku_map_message')}}
          </div>
          <div class="text-sm pt-2">
            {{$t('tour_mobaku_map_message2')}}
          </div>
          <div class="text-sm pt-2">
            {{$t('tour_mobaku_map_message3')}}
          </div>
          <div class="pt-2">
            <a href="https://mobaku.jp/" class="break-all text-link" target="_blank">{{$t('tour_mobaku_web')}}</a>
          </div>
          <div class="pt-2">
            <a href="https://www.nttdocomo.co.jp/utility/privacy/" class="break-all text-link" target="_blank">{{$t('tour_privacy')}}</a>
          </div>
          <div class="pt-2">
            <a href="https://mobakumap.jp/about.html" class="break-all text-link" target="_blank">{{$t('tour_mobaku_about')}}</a>
          </div>
          <div class="pt-2">
            <a href="https://policies.google.com/technologies/partner-sites?hl=ja" class="break-all text-link" target="_blank">{{$t('tour_google_policy')}}</a>
          </div>
        </div>
        <div class="mt-4">
          <a class="button-primary block" @click="closeMobaku">
            <span class="block whitespace-nowrap text-xs">{{$t('tour_close_label')}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from '../../../constants'

export default {
  data () {
    return {};
  },
  mounted() {
    if (Constants.ENABLED_DOCOMO_MOBAKU) {
      let script = document.createElement('script')
      script.onload = () => {
        // this.$store.dispatch('googleMap/initDocomoMobaku')
        this.$store.dispatch('user/offFilterFromTag', "mobaku")
      }
      script.async = true
      script.src = 'https://jre-maas.mobakumap.jp/js/app.js'
      document.head.appendChild(script)
    }
  },
  methods: {
    closeMobaku: function () {
      this.$store.dispatch('map/setShowDocomoMobaku', false)
    }
  }
}
</script>
